import { DOMParser, onErrorStopParsing } from '@xmldom/xmldom';

export function parseGeoTiffMetadata(xml: string) {
  const values = {
    smallestValue: 1,
    largestValue: 4,
    baseHeightValue: 0,
  };
  let document;
  try {
    // This code also runs in Web Workers, where the browser DOMParser is absent.
    document = new DOMParser({ onError: onErrorStopParsing }).parseFromString(
      xml,
      'text/xml'
    );
  } catch {
    return values;
  }

  for (const item of Array.from(document.getElementsByTagName('Item'))) {
    const value = parseFloat(item.textContent || '');
    if (!Number.isFinite(value)) continue;

    switch (item.getAttribute('name')) {
      case 'MINBANDVALUE':
        values.smallestValue = value;
        break;
      case 'MAXBANDVALUE':
        values.largestValue = value;
        break;
      case 'ZOFFSET':
        values.baseHeightValue = value;
        break;
    }
  }
  return values;
}
